'use client'

import type { CheckboxProps } from '@pearlconvert/ui/components/checkbox/checkbox.types'

import classNames from 'classnames'
import React from 'react'

import '@pearlconvert/ui/components/checkbox/styles/checkbox.scss'

const Checkbox: React.FC<CheckboxProps> = ({
  id,
  label,
  success: _success = false,
  error,
  hint,
  optionalText,
  componentName = 'checkbox',
  className,
  isSwitch,
  controlSize,
  ...inputProps
}: CheckboxProps) => {
  if (isSwitch) {
    componentName = 'switch'
  }

  const rootClass = classNames(className, `${componentName}__root`, {
    [`${componentName}__root--${controlSize}`]: controlSize,
    [`${componentName}__root--error`]: error,
    [`${componentName}__root--has-text-optional`]: optionalText,
  })
  const labelClass = classNames(`${componentName}__label`, {
    [`${componentName}__label--error`]: error,
  })

  return (
    <div className={rootClass}>
      <input
        type="checkbox"
        id={id}
        className={componentName + '__input'}
        {...((error && { 'aria-describedby': 'error__' + id }) ||
          (hint && { 'aria-describedby': 'hint__' + id }) ||
          (error && hint && { 'aria-describedby': 'error__' + id }))}
        {...(isSwitch && { role: 'switch' })}
        {...inputProps}
      />
      <label className={labelClass} htmlFor={id}>
        {typeof label === 'string' ? (
          <span className={componentName + '__text'}>
            {label}
            {optionalText && (
              <span className={componentName + '__text--optional'}>
                {optionalText}
              </span>
            )}
          </span>
        ) : (
          <>
            {label}
            {optionalText && (
              <span className={componentName + '__text--optional'}>
                {optionalText}
              </span>
            )}
          </>
        )}
      </label>
      {error && (
        <p
          className={componentName + '__message'}
          id={'error__' + id}
          role="alert"
          aria-live="polite"
          aria-hidden={false}
        >
          {error}
        </p>
      )}
      {hint && (
        <p
          className={componentName + '__hint'}
          id={'hint__' + id}
          aria-live="polite"
          aria-hidden={false}
        >
          {hint}
        </p>
      )}
    </div>
  )
}

export default Checkbox
